import _ from 'lodash'

export const savingsPoolUpdateInterestRateWithBreakGlass = _.template(`{
  DROP;
  NIL operation;
  PUSH address "<%= breakGlassContract %>"; # Savings Pool Break Glass
  CONTRACT %runLambda (lambda unit (list operation));
  IF_NONE { PUSH int 42; FAILWITH } {};
  PUSH mutez 0;
  LAMBDA unit (list operation) {
    DROP;
    NIL operation;
    PUSH address "<%= contract %>"; # Savings Pool
    CONTRACT %setInterestRate nat;
    IF_NONE { PUSH int 12; FAILWITH } {};
    PUSH mutez 0;
    PUSH nat <%= interestRatePercentage %>; # Interest Rate Percentage - https://www.wolframalpha.com/input/?i=SetPrecision%5B%28%281.<%= interestRatePercentage.padStart(18, '0') %>%5E%28365+*+24+*+60%29%29+-+1%29+*+100%2C+18%5D
    TRANSFER_TOKENS;
    CONS;
  };
  TRANSFER_TOKENS;
  CONS;
}`)

export const savingsPoolUpdateInterestRateWithoutBreakGlass = _.template(`{
  DROP;
  NIL operation;
  PUSH address "<%= contract %>"; # Savings Pool
  CONTRACT %setInterestRate nat;
  IF_NONE { PUSH int 12; FAILWITH } {};
  PUSH mutez 0;
  PUSH nat <%= interestRatePercentage %>; # Interest Rate Percentage - https://www.wolframalpha.com/input/?i=SetPrecision%5B%28%281.0000000<%= interestRatePercentage.padStart(18, '0') %>%5E%28365+*+24+*+60%29%29+-+1%29+*+100%2C+18%5D
  TRANSFER_TOKENS;
  CONS;
}`)

